import { MultiColumnList } from '@folio/stripes/components';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { containsFullOvernightSpans, containsNextDayOvernight, generateDisplayRows, get247Rows, splitOpeningsIntoDays, } from '../utils/InfoPaneUtils';
import { isOpen247 } from '../utils/CalendarUtils';
import { useLocaleWeekdays } from '../utils/WeekdayUtils';
import css from '../views/panes/InfoPane.css';
export default function InfoPaneHours(_a) {
    var calendar = _a.calendar;
    var intl = useIntl();
    var localeWeekdays = useLocaleWeekdays(intl);
    var hours = useMemo(function () { return splitOpeningsIntoDays(calendar.normalHours); }, [calendar]);
    var dataRows = useMemo(function () {
        if (isOpen247(calendar.normalHours)) {
            return get247Rows(intl, localeWeekdays);
        }
        else {
            return generateDisplayRows(intl, localeWeekdays, hours);
        }
    }, [hours, calendar, intl, localeWeekdays]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MultiColumnList, { interactive: false, getCellClass: function (defaultClass, _rowData, column) {
                var _a;
                return classNames(defaultClass, (_a = {},
                    _a[css.hoursCell] = column !== 'day',
                    _a[css.dayCell] = column === 'day',
                    _a));
            }, columnMapping: {
                day: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.hours.day" })),
                startTime: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.hours.open" })),
                endTime: (React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.accordion.hours.close" })),
            }, columnWidths: {
                day: 200,
                startTime: { min: 100, max: 100 },
                endTime: { min: 100, max: 100 },
            }, contentData: dataRows }),
        React.createElement("p", { className: !isOpen247(calendar.normalHours) && containsNextDayOvernight(hours)
                ? ''
                : css.hidden },
            React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.nextDayHelpText" })),
        React.createElement("p", { className: !isOpen247(calendar.normalHours) && containsFullOvernightSpans(hours)
                ? ''
                : css.hidden },
            React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.overnightHelpText" })),
        React.createElement("p", { className: isOpen247(calendar.normalHours) ? '' : css.hidden },
            React.createElement(FormattedMessage, { id: "ui-calendar.infoPane.247HelpText" }))));
}
